import { KdsText } from "@kazaar-platform/design-system";
import { type OrderItemPageActivityLogSimpleProps } from "./OrderItemPageActivityLogSimple.types";

export const OrderItemPageActivityLogSimple = ({
  content,
}: OrderItemPageActivityLogSimpleProps) => {
  return (
    <div className="flex items-center gap-sp-xs2">
      <KdsText>{content}</KdsText>
    </div>
  );
};
